import React, { useEffect, useState } from "react";
import PWIBlocktable from "./PWIBlocktable";
import TypeWisePWIData from "./TypeWisePWIData";
import axios from "axios";
import { BiSolidReport } from "react-icons/bi";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import Loading from "../../../../Extra/Loading";
import NoDataFound from "../../../../Extra/NoDataFound";
import ReasonWise from "./ReasonWise";

const PWIMaster = ({ data }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [pwiData, setPwiData] = useState([]);

  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getblockpwinotavailed?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setPwiData(response.data.data);
      } else {
        setPwiData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);
  return (
    <div>
      <div className="papaDiv">
        <ReasonWise data={data} />
      </div>
      <div className="bg-dark text-white p-1 d-flex justify-content-between align-items-center papaDiv">
        <div>
          <h5 className="text-center">
            {" "}
            <BiSolidReport />
            BLOCK NOT AVAILED
            <b style={{ color: "#b2b0b0ff" }}> (Eng PWI wise)</b>
          </h5>
        </div>
        <div className="d-flex">
          <div className="m-1">
            <b>Start Date</b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              // className="form-control"
            />
          </div>
          <div className="m-1">
            <b>End Date</b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              // className="form-control"
            />
          </div>
          <button
            className="ms-1 btn btn-sm btn-outline-light"
            onClick={fetchedData}
          >
            Fetch
          </button>
        </div>
      </div>
      <div className="">
        <div className="position-relative">
          {loading && <Loading />}
          <PWIBlocktable
            pwiData={pwiData}
            startDate={startDate}
            endDate={startDate}
          />
          {pwiData.length === 0 && <NoDataFound />}
        </div>
        <div>
          <TypeWisePWIData
            pwiData={pwiData}
            loading={loading}
            error={error}
            startDate={startDate}
            endDate={startDate}
          />
        </div>
      </div>
    </div>
  );
};

export default PWIMaster;
